import { Component } from '@angular/core';

@Component({
  selector: 'app-quick-upload-showcase',
  templateUrl: './quick-upload-showcase.component.html',
  styleUrls: ['./quick-upload-showcase.component.scss']
})
export class QuickUploadShowcaseComponent {
  basicRecords: any[] = [];

  preloadedRecords: any[] = [
    { name: 'Alice Johnson', email: 'alice@example.com', region: 'Americas' },
    { name: 'Bob Smith', email: 'bob@example.com', region: 'EMEA' },
    { name: 'Carol Davis', email: 'carol@example.com', region: 'APJC' },
  ];

  customLabelRecords: any[] = [
    { product: 'Cisco Catalyst', sku: 'CC-9300', qty: 5 },
    { product: 'Cisco Meraki', sku: 'MR-42', qty: 2 },
  ];

  lastEvent: string = '';

  onFileSelected(rows: any[], context: string): void {
    if (context === 'basic') { this.basicRecords = rows; }
    this.lastEvent = context + ': ' + rows.length + ' rows parsed';
    console.log('File selected (' + context + '):', rows);
  }

  onCleared(context: string): void {
    if (context === 'preloaded') { this.preloadedRecords = []; }
    if (context === 'custom') { this.customLabelRecords = []; }
    if (context === 'basic') { this.basicRecords = []; }
    this.lastEvent = context + ': cleared';
    console.log('Cleared (' + context + ')');
  }

  onViewRecords(context: string): void {
    this.lastEvent = context + ': view records clicked';
    console.log('View records (' + context + ')');
  }

  onDownloadTemplate(context: string): void {
    this.lastEvent = context + ': download template clicked';
    console.log('Download template (' + context + ')');
  }
}
